// components/user-tour/demoData.js

export const DEMO_PATIENT_CONTEXT = {
  name: "Jordan Rivera",
  firstName: "Jordan",
  lastName: "Rivera",
  age: 45,
  gender: "Male",
  visitType: "follow_up",
  dateOfService: new Date().toISOString().split("T")[0],
};

// Fed into the transcript UI line-by-line to mimic live STT output
export const DEMO_TRANSCRIPT_LINES = [
  "Speaker 1: Oh, boy.",
  "Speaker 1: Okay.",
  "Speaker 1: What happened?",
  "Speaker 1: You are not able to make it to the clinic?",
  "Speaker 2: I did.",
  "Speaker 2: Hurts to walk.",
  "Speaker 1: Oh, boy.",
  "Speaker 2: It it happens every once in a while.",
  "Speaker 2: You know?",
  "Speaker 2: By turning on, there's something Okay.",
  "Speaker 1: You have this the the tramadol.",
  "Speaker 1: Do you have that pain medication that Yeah.",
  "Speaker 2: I do.",
  "Speaker 2: Yeah.",
  "Speaker 1: So the take that one as needed basis and put some heating pad and drops Uh-huh.",
  "Speaker 1: And then see how that goes.",
  "Speaker 2: Yeah.",
  "Speaker 1: And and regarding your labs, your vitamin d level is very, very low.",
  "Speaker 1: Okay?",
  "Speaker 2: My d Vitamin d Yeah.",
  "Speaker 1: It should be at least thirty and forty fifty would be a right amount.",
  "Speaker 1: Value, but yours 12.",
  "Speaker 1: Very low.",
  "Speaker 2: Oh, wow.",
  "Speaker 1: Have you have you been taking the vitamin d supplement?",
  "Speaker 2: Yeah.",
  "Speaker 2: I've been taking the complex No.",
  "Speaker 2: Just the d three itself.",
  "Speaker 1: Oh, okay.",
  "Speaker 1: Okay.",
  "Speaker 1: So you are not taking that one.",
  "Speaker 2: Yeah.",
  "Speaker 2: No. [translated from Spanish]",
  "Speaker 2: See, I was taking the b count.",
  "Speaker 2: Complex.",
  "Speaker 2: Yeah.",
  "Speaker 1: B complex is different.",
  "Speaker 1: That does not have vitamin D in it.",
  "Speaker 2: Okay.",
  "Speaker 2: Alright.",
  "Speaker 2: Okay.",
  "Speaker 1: You need to you need to get vitamin d three over the counter.",
  "Speaker 2: I am in d three.",
  "Speaker 2: Five thousand units.",
  "Speaker 1: Okay.",
  "Speaker 1: Write it down.",
  "Speaker 1: Vitamin D three Yeah.",
  "Speaker 1: Five thousand units.",
  "Speaker 1: Yeah.",
  "Speaker 1: Once a day.",
  "Speaker 1: Okay.",
  "Speaker 1: You need to buy that one.",
  "Speaker 1: It's not that expensive.",
  "Speaker 1: You can buy like, a a big bottle because you are going to take it every day.",
  "Speaker 1: Okay.",
  "Speaker 2: We'll do Yeah.",
  "Speaker 1: Rest of the labs are fine.",
  "Speaker 1: Your kidney test and the liver test cholesterol, everything is excellent.",
  "Speaker 1: And your sugar level is doing stable.",
  "Speaker 1: It's borderline, but nothing has changed.",
  "Speaker 1: From previous one.",
  "Speaker 1: So continue all these medications.",
  "Speaker 1: And take the vitamin d And anything else we need to talk about today?",
  "Speaker 2: I think that's what it He said he only say, you know, I've been I've been okay.",
  "Speaker 2: Just because the pain with the fibromyalgia with, you know, it it helps.",
  "Speaker 2: The the the tramadol helps.",
  "Speaker 1: Okay.",
  "Speaker 1: And then I will see you in four or five months for your annual visit.",
  "Speaker 1: Because it's going to be your annual visit We need to see you in person next time.",
  "Speaker 1: Okay.",
  "Speaker 1: Okay?",
  "Speaker 1: We will we will we will call you with appointments.",
  "Speaker 1: Okay.",
  "Speaker 1: Great.",
  "Speaker 1: Got you.",
  "Speaker 1: Okay then.",
  "Speaker 1: Have a good day.",
  "Speaker 1: Take care.",
  "Speaker 1: Okay?",
  "Speaker 1: Alright then.",
  "Speaker 2: You too.",
  "Speaker 2: Okay.",
  "Speaker 2: Bye bye.",
  "Speaker 2: Bye bye.",
];

// Updated SOAP note with comprehensive subsections (CC, HPI, ROS, PMH, Medications, Labs, etc.)
export const DEMO_SOAP_NOTE = {
  soapNoteId: "demo-soap-note",
  sessionId: "demo-session",
  version: 1,
  status: "draft",
  icd10Codes: ["E55.9", "M79.7", "R73.03", "Z00.01"],
  metadata: { hpiDepthLevel: 3, generatedAt: new Date().toISOString(),
    hpiVariants: {
      1: "**HPI (Concise):** 45-year-old male with vitamin D deficiency, fibromyalgia, prediabetes. Follow-up. No acute issues.",
      2: "**HPI (Balanced):** 45-year-old male with chronic fibromyalgia, vitamin D deficiency, and prediabetes. Presents for annual follow-up. Labs show vitamin D 12, glucose borderline. Pain managed with tramadol.",
      3: "**HPI (Detailed):** Jordan Rivera presents with follow-up of chronic medical conditions and review of recent laboratory results. Recent laboratory studies were reviewed. Kidney function, liver function, and cholesterol testing were reported as excellent. Blood glucose levels remain borderline but unchanged from prior testing. He reports that he has otherwise been doing well and has no new major concerns.Laboratory review was notable for significant vitamin D deficiency with a vitamin D level of 12. He was questioned regarding vitamin D supplementation and initially reported taking a B-complex vitamin. During medication reconciliation it became apparent that he had not been taking a dedicated vitamin D3 supplement, as the B-complex preparation does not contain adequate vitamin D supplementation. He denied currently taking vitamin D3.He also discussed intermittent pain related to fibromyalgia. He reports episodes of pain that occasionally make walking difficult. The symptoms occur intermittently. He has tramadol available and reports that tramadol provides relief when needed. No additional associated symptoms were discussed.The patient's medication list was reviewed and reconciled in detail. He reports overall stability on his current medication regimen and states that he has been okay since his last visit."
    }
  },
  structuredSections: {
    subjective: `**CC:**
- Annual wellness visit/follow-up visit; review of laboratory results

**HPI:**
Jordan Rivera presents with follow-up of chronic medical conditions and review of recent laboratory results. Recent laboratory studies were reviewed. Kidney function, liver function, and cholesterol testing were reported as excellent. Blood glucose levels remain borderline but unchanged from prior testing. He reports that he has otherwise been doing well and has no new major concerns.

Laboratory review was notable for significant vitamin D deficiency with a vitamin D level of 12. He was questioned regarding vitamin D supplementation and initially reported taking a B-complex vitamin. During medication reconciliation it became apparent that he had not been taking a dedicated vitamin D3 supplement, as the B-complex preparation does not contain adequate vitamin D supplementation. He denied currently taking vitamin D3.

He also discussed intermittent pain related to fibromyalgia. He reports episodes of pain that occasionally make walking difficult. The symptoms occur intermittently. He has tramadol available and reports that tramadol provides relief when needed. No additional associated symptoms were discussed.

The patient's medication list was reviewed and reconciled in detail. He reports overall stability on his current medication regimen and states that he has been okay since his last visit.

**ROS:**
- Constitutional: Denies acute constitutional symptoms.
- HEENT: Not documented.
- Cardiovascular: Denies acute cardiovascular symptoms.
- Respiratory: Denies acute respiratory symptoms.
- Gastrointestinal: Denies acute gastrointestinal symptoms.
- Genitourinary: Not documented.
- Musculoskeletal: Reports intermittent generalized pain and difficulty walking during pain flares.
- Skin: Not documented.
- Neurological: Not documented.
- Psychiatric: Denies acute psychiatric symptoms.
- Endocrine: Not documented.
- Hematologic/Lymphatic: Not documented.
- Allergic/Immunologic: Not documented.

**PMH:**
- Fibromyalgia
- Vitamin D deficiency
- Borderline hyperglycemia/prediabetes

**Surgical History:**
- Not documented

**Hospitalization History:**
- Not documented

**Medications:**
- Tramadol
- Vitamin D3 5,000 units daily (recommended today)
- Other chronic medications reviewed; specific medications not documented

**Medication Intolerance:**
- Not documented

**Allergies:**
- Not documented

**Social History:**
- Not documented

**Family History:**
- Not documented

**Preventive Medicine:**
- Annual wellness visit performed.
- Provider advised in-person annual visit at next follow-up.`,

    objective: `**Vitals:**
- Not documented

**Physical Exam:**
- Not applicable/Not documented (telephone encounter inferred from discussion regarding inability to come to clinic)

**Labs:**
- Vitamin D: 12 (very low)
- Kidney function testing: reported as normal/excellent
- Liver function testing: reported as normal/excellent
- Cholesterol testing: reported as excellent
- Blood glucose: borderline, unchanged from previous testing

**Imaging/Studies:**
- Not documented

**Procedures:**
- None documented`,

    assessment: `**Vitamin D Deficiency (E55.9):**

Recent laboratory testing demonstrates severe vitamin D deficiency with a reported level of 12. The patient was not taking a dedicated vitamin D supplement and had been taking a B-complex vitamin instead.

**Plan:**
- Start vitamin D3 5,000 units orally once daily (over-the-counter).
- Educated patient regarding the difference between B-complex vitamins and vitamin D supplementation.
- Advised daily long-term compliance with vitamin D replacement.
- Recheck vitamin D level at future follow-up.

**Fibromyalgia (M79.7):**

Chronic fibromyalgia with intermittent pain flares causing occasional difficulty with ambulation. Symptoms remain responsive to tramadol as needed.

**Plan:**
- Continue tramadol as previously prescribed on an as-needed basis.
- Recommend local heat therapy/heating pad during symptom flares.
- Monitor symptom frequency and functional status.

**Prediabetes (R73.03):**

Blood glucose status remains borderline but unchanged from previous laboratory evaluation. No evidence of interval worsening was discussed.

**Plan:**
- Continue current medications and lifestyle measures.
- Continue periodic laboratory monitoring.
- Reinforced adherence to current treatment regimen.

**Encounter for General Adult Medical Examination with Abnormal Findings (Z00.01):**

Annual wellness visit completed with review of chronic medical conditions and laboratory studies. Abnormal finding includes significant vitamin D deficiency.

**Plan:**
- Reviewed laboratory results in detail.
- Continue current chronic disease management.
- Schedule next annual wellness evaluation in person.`,

    plan: `**Follow-Up Instructions:**
- Follow-up with me in 4-5 months for annual wellness visit.

**Signature:**
Demo Visit
Physician
xx-xx-20xx`,
  },
};

// Helper to simulate ICD code changes for demo (no API)
export const DEMO_ICD_HELPER = {
  // Replace an ICD code in the given text (assessment or plan)
  replaceCode: (text, oldCode, newCode, newDescription) => {
    const oldNorm = oldCode.toUpperCase();
    const newNorm = newCode.toUpperCase();
    const regex = new RegExp(`\\(${oldNorm}\\)`, 'g');
    let updated = text.replace(regex, `(${newNorm})`);
    // Also update the heading if it contains the old code
    const headingRegex = new RegExp(`\\*\\*([^*]+?)\\s*\\(${oldNorm}\\)\\s*\\*\\*`, 'g');
    updated = updated.replace(headingRegex, (match, label) => {
      const newLabel = newDescription || label;
      return `**${newLabel} (${newNorm}):**`;
    });
    return updated;
  }
};